import React, { useState, useEffect } from 'react';
import { useGetCurrencyListQuery, useUpdateCurrencyMutation } from "../../Services/SettingsAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faEdit, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import "./style.css"


function Index() {
    const { data, contentLoading, refetch } = useGetCurrencyListQuery();
    const currencyData = data?.data;
    const [updateCurrency] = useUpdateCurrencyMutation();

    const [isEditing, setIsEditing] = useState(false);
    const [editedCurrency, setEditedCurrency] = useState({
        symbol: '',
        text: ''
    });

    useEffect(() => {
        if (currencyData) {
            setEditedCurrency({
                symbol: currencyData?.symbol,
                text: currencyData?.text
            });
        }
    }, [currencyData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedCurrency(prev => ({ ...prev, [name]: value }));
    };

    const handleEditSaveClick = async (e) => {
        if (isEditing) {
            // Save mode
            const payload = {
                currency_id: currencyData?.id,
                currency_text: editedCurrency?.text,
            };

            try {
                const response = await updateCurrency(payload).unwrap();
                alert("Data updated successfully!");
                refetch();
                console.log("response", response)
            } catch (error) {
                alert(error.data?.message || "Something went wrong");
            }


        }

        setIsEditing(!isEditing);
    };

    if (contentLoading) return <div class="loader"></div>;

    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Currency <div className="tooltip-container">
                <FontAwesomeIcon
                    icon={faCircleInfo}
                    className="text-warning mx-2"
                    style={{ cursor: "pointer" }}
                />
                <div className="tooltip">Only the currency text can be changed.</div>
            </div></h2>
            <div className='table-responsive update-currency-table'>
                <table border="1" cellPadding="10" className="table table-bordered payment-mode-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th className='key-head'>Symbol</th>
                            <th className='key-head'>Text</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{currencyData?.id}</td>
                            <td>
                                <input
                                    type="text"
                                    name="symbol"
                                    value={editedCurrency?.symbol}
                                    onChange={handleChange}
                                    readOnly={!isEditing}
                                    className="form-control"
                                    disabled
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    name="text"
                                    value={editedCurrency?.text}
                                    onChange={handleChange}
                                    readOnly={!isEditing}
                                    className="form-control"
                                />
                            </td>
                            <td>
                                <button onClick={handleEditSaveClick} className='currency-update-action'>
                                    {isEditing ? <FontAwesomeIcon
                                        icon={faSave}
                                        className=" mx-2"
                                        style={{ cursor: "pointer" }}
                                    /> : <FontAwesomeIcon
                                        icon={faEdit}
                                        className=" mx-2"
                                        style={{ cursor: "pointer" }}
                                    />}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Index;
